function parseQueryString(q: string) {
  const d: { [key: string]: string } = {}
  q.split('&').map((kv) => kv.split('=')).filter((kv) => kv.length === 2).forEach(([k, v]) => {
    d[k] = decodeURIComponent(v)
  })
  return d
}

export const queryParams = (() => {
  const q = parseQueryString(location.search.substr(1))
  const mode = (() => {
    if (['embedded', 'jupyter'].indexOf(q.mode) >= 0) {
      return q.mode
    }
    return 'window'
  })()
  const jupyter = ['jupyter'].indexOf(mode) >= 0
  const inline = ['embedded'].indexOf(mode) >= 0
  return {
    mode,
    jupyter,
    inline,
  }
})()
